import type { MessageEnvelope, WidgetOptions } from './types';

export function resolveElement(target: string | HTMLElement): HTMLElement {
  if (typeof document === 'undefined') {
    throw new Error('AIFindrCommerceWidget requires a browser environment.');
  }

  if (target instanceof HTMLElement) {
    return target;
  }

  const element = document.querySelector<HTMLElement>(target);
  if (!element) {
    throw new Error(`AIFindrCommerceWidget: render target "${target}" was not found in the DOM.`);
  }
  return element;
}

export function buildIframeSrc(baseUrl: string, clientId: string, handshake: string): string {
  let url: URL;
  try {
    url = new URL(baseUrl);
  } catch (error) {
    throw new Error(`AIFindrCommerceWidget: invalid baseUrl provided (${baseUrl}).`);
  }

  url.searchParams.set('client_id', clientId);
  url.searchParams.set('handshake', handshake);
  return url.toString();
}

export function getOrigin(url: string): string {
  const parsed = new URL(url);
  return parsed.origin;
}

export function createHandshakeId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  const random = Math.random().toString(16).slice(2);
  const time = Date.now().toString(16);
  return `hs_${time}_${random}`;
}

export function normalizeOptions(options: WidgetOptions): WidgetOptions {
  return {
    iframeTitle: 'AIFindr Commerce Widget',
    ...options,
  };
}

export function isMessageEnvelope(value: unknown): value is MessageEnvelope {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const candidate = value as Partial<MessageEnvelope>;
  return typeof candidate.source === 'string'
    && typeof candidate.type === 'string'
    && typeof candidate.handshake === 'string';
}
